import { normalize } from 'normalizr'
import { all } from 'redux-saga/effects'
import { customerGiftRedeemedEntity } from 'redux/entities'
import pagaSaga from 'redux/pagination/sagas'
import actions from './actions'

const norm = data => normalize(data?.rewards ?? [], [customerGiftRedeemedEntity])

export default function* rootSaga() {
  yield all([...pagaSaga([actions.LIST_CUSTOMER_GIFTS_REDEEMED, actions.LIST_CUSTOMER_GIFTS_REDEEMED_NEXT], norm)])
}
